import React, { useContext, useEffect, useRef, useState } from 'react';

import * as S from './styles';
import { color } from 'styles/pallete';
import { Product } from 'types/Product';
import CardProduct from 'components/CardProduct';
import { getProductByCollectionOrQuery } from 'components/DataProductsCarousel/reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import Load from 'components/Load';

interface CarrosselProductsScreenStaticsProps {
	query: string;
	colorBackGroud?: string;
}

export default function CarrosselProductsScreenStatics({
	query,
	colorBackGroud = color.interface.white
}: CarrosselProductsScreenStaticsProps) {
	const listRef = useRef<HTMLDivElement>(null);
	const scrollSpeed = 1; // Ajuste a velocidade do scroll aqui
	const { handleNotify } = useContext(SystemNotifyContext);
	const [load, setLoad] = useState(false);
	const [products, setProducts] = useState<Product[]>([]);

	//passa automaticamente para o lado o carrossel
	useEffect(() => {
		const list = listRef.current;
		if (!list) return;

		let scrollInterval: NodeJS.Timeout | null = null;

		const startScrolling = () => {
			if (scrollInterval) return;

			scrollInterval = setInterval(() => {
				if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
					list.scrollLeft = 0; // Reinicia o scroll quando chega ao final
				} else {
					list.scrollLeft += scrollSpeed;
				}
			}, 35);
		};

		const stopScrolling = () => {
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}
		};

		startScrolling();

		list.addEventListener('mouseenter', stopScrolling);
		list.addEventListener('mouseleave', startScrolling);

		return () => {
			stopScrolling();
			list.removeEventListener('mouseenter', stopScrolling);
			list.removeEventListener('mouseleave', startScrolling);
		};
	}, [load]);

	//busca produtos
	useEffect(() => {
		if (query !== '') {
			(async () => {
				setLoad(true);
				const productsResp = await getProductByCollectionOrQuery(
					query,
					handleNotify
				);
				setLoad(false);

				if (productsResp.products.length > 0) {
					setProducts(productsResp.products);
				}
			})();
		}
	}, [query]);

	return (
		<S.container $backGroundColor={colorBackGroud}>
			{load && (
				<S.load>
					<Load showText text="Carregando produtos" />
				</S.load>
			)}
			{products.length > 0 && (
				<S.listProducts ref={listRef} $isLoad={load}>
					{products.length > 0 &&
						products.map((product, i) => (
							<S.product key={product.productId || i}>
								<CardProduct product={product} />
							</S.product>
						))}
				</S.listProducts>
			)}

			{!load && products.length === 0 && (
				<S.noBanners>
					<p>Não há produtos</p>
				</S.noBanners>
			)}
		</S.container>
	);
}
